import {TFetch} from "../../types";
import reducerStatuses from "../../status";
import {createReducer, PayloadAction} from "@reduxjs/toolkit";
import {DONE, FAIL, FETCH, MATERIALS_GAME, MATERIALS_GAME_CATEGORIES,MATERIALS ,MATERIALS_GAMES, MATERIALS_CARDS, MATERIALS_CARD, TALES, INFOGRAPHICS, MATERIALS_TREE, MATERIALS_DETAIL, KINDERGARTENS_LIST, CHILDRENS, MAIN_VIDEO_LIST, CONTENT_BY_LESSON, EXPORT_PDF, SENSORY_VIDEO_LIST, EXPORT_RESULTS_PDF, INFOGRAPHICS_BY_CODE, ARTICLE_BY_ID, DELETE_CHILD, PSYCHO_CARDS_LIST, UPDATE_PROFILE, ADD_CHILD, UPDATE_CHILD, CARDS_THEME_LIST, EVALUATE, RESET, TEST_RESULTS, REGIONS_LIST, DISTRICTS_LIST, CITIES_LIST, LIST_REQUEST, CREATE_APPLICATION, SET_LIKE, CONTENT_BY_CATEGORY, FETCH_MARATHON_WEEKS, FETCH_MARATHON_DAYS, FETCH_MARATHON_TASKS, FETCH_MARATHON_TASK, SAVE_DIARY, FETCH_DIARY, FETCH_DIARY_TABLE, TASK_COMPLETE, SET, SELECTED_CHILD_ID, DIAGNOSTIC_RESULT, TASK_COMPLETED_LOCAL} from "../../constants";


const initialState: TFetch = {
  gameCategories: {
    ...reducerStatuses,
    data: [] as any,
  },
  gamesList: {
    ...reducerStatuses,
    data: [] as any,
  },
  cardsList: {
    ...reducerStatuses,
    data: [] as any,
  },
  talesList: {
    ...reducerStatuses,
    data: [] as any,
  },
  oneGame: {
    ...reducerStatuses,
    data: {} as any,
  },
  oneCard: {
    ...reducerStatuses,
    data: {} as any,
  },
  materials: {
    ...reducerStatuses,
    data: [] as any,
  },
  infographics: {
    ...reducerStatuses,
    data: [] as any,
  },
  materialsTree: {
    ...reducerStatuses,
    data: [] as any,
  },
  materialsDetail: {
    ...reducerStatuses,
    data: [] as any,
  },
  kindergartensList: {
    ...reducerStatuses,
    data: [] as any,
  },
  childrens: {
    ...reducerStatuses,
    data: [] as any,
  },
  mainVideoList: {
    ...reducerStatuses,
    data: [] as any,
  },
  contentByLesson: {
    ...reducerStatuses,
    data: [] as any,
  },
  exportPDF: {
    ...reducerStatuses,
    data: [] as any,
  },
  sensoryVideoList: {
    ...reducerStatuses,
    data: [] as any,
  },
  exportResultsPDF: {
    ...reducerStatuses,
    data: [] as any,
  },
  infographicsByCode: {
    ...reducerStatuses,
    data: [] as any,
  },
  deleteChild: {
    ...reducerStatuses,
    data: null as any,
  },
  articleById: {
    ...reducerStatuses,
    data: [] as any,
  },
  psychoCardsList: {
    ...reducerStatuses,
    data: [] as any,
  },
  updateProfile: {
    ...reducerStatuses,
    data: [] as any,
  },
  addChild: {
    ...reducerStatuses,
    data: [] as any,
  },
  updateChild: {
    ...reducerStatuses,
    data: [] as any,
  },
  cardsThemeList: {
    ...reducerStatuses,
    data: [] as any,
  },
  evaluate: {
    ...reducerStatuses,
    data: [] as any,
  },
  testResults: {
    ...reducerStatuses,
    data: null as any,
  },
  regionsList: {
    ...reducerStatuses,
    data: null as any,
  },
  districtsList: {
    ...reducerStatuses,
    data: null as any,
  },
  citiesList: {
    ...reducerStatuses,
    data: null as any,
  },
  listRequest: {
    ...reducerStatuses,
    data: null as any,
  },
  createApplication: {
    ...reducerStatuses,
    data: null as any,
  },
  setLike: {
    ...reducerStatuses,
    data: null as any,
  },
  contentByCategory: {
    ...reducerStatuses,
    data: null as any,
  },
  weeksList: {
    ...reducerStatuses,
    data: [] as any,
  },
  daysList: {
    ...reducerStatuses,
    data: [] as any,
  },
  tasksList: {
    ...reducerStatuses,
    data: [] as any,
  },
  tasksByDay: {
    ...reducerStatuses,
    data: [] as any,
  },
  taskDetail: {
    ...reducerStatuses,
    data: [] as any,
  },
  saveDiary: {
    ...reducerStatuses,
    data: [] as any,
  },
  diary: {
    ...reducerStatuses,
    data: [] as any,
  },
  diaryTable: {
    ...reducerStatuses,
    data: [] as any,
  },
  taskComplete: {
    ...reducerStatuses,
    data: [] as any,
  },
  selectedChildId: {
    ...reducerStatuses,
    data: (() => {
      try {
        const stored = localStorage.getItem('selectedChildId');
        return stored ? Number(stored) : null;
      } catch {
        return null;
      }
    })() as any,
  },
  diagnosticResults: {
    ...reducerStatuses,
    data: (() => {
      try {
        const stored = localStorage.getItem('diagnosticResults');
        return stored ? JSON.parse(stored) : {};
      } catch {
        return {};
      }
    })() as Record<string, any>,
  },
}


export default createReducer(initialState, builder =>
  builder
    .addCase(MATERIALS_GAME_CATEGORIES + FETCH, (state) => ({
      ...state,
      gameCategories: {
        ...initialState.gameCategories,
        loading: true
      }
    }))
    .addCase(MATERIALS_GAME_CATEGORIES + FETCH + DONE, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      gameCategories: {
        ...initialState.gameCategories,
        success: true,
        data: payload
      }
    }))
    .addCase(MATERIALS_GAME_CATEGORIES + FETCH + FAIL, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      gameCategories: {
        ...initialState.gameCategories,
        failed: true,
        // todo: Костыль
        data: payload
      }
    }))
    .addCase(MATERIALS_GAMES + FETCH, (state) => ({
      ...state,
      gamesList: {
        ...initialState.gamesList,
        loading: true
      }
    }))
    .addCase(MATERIALS_GAMES + FETCH + DONE, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      gamesList: {
        ...initialState.gamesList,
        success: true,
        data: payload
      }
    }))
    .addCase(MATERIALS_GAMES + FETCH + FAIL, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      gamesList: {
        ...initialState.gamesList,
        failed: true,
        // todo: Костыль
        data: payload
      }
    }))
    .addCase(TALES + FETCH, (state) => ({
      ...state,
      talesList: {
        ...initialState.talesList,
        loading: true
      }
    }))
    .addCase(TALES + FETCH + DONE, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      talesList: {
        ...initialState.talesList,
        success: true,
        data: payload
      }
    }))
    .addCase(TALES + FETCH + FAIL, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      talesList: {
        ...initialState.talesList,
        failed: true,
        // todo: Костыль
        data: payload
      }
    }))
    .addCase(MATERIALS_CARDS + FETCH, (state) => ({
      ...state,
      cardsList: {
        ...initialState.cardsList,
        loading: true
      }
    }))
    .addCase(MATERIALS_CARDS + FETCH + DONE, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      cardsList: {
        ...initialState.cardsList,
        success: true,
        data: payload
      }
    }))
    .addCase(MATERIALS_CARDS + FETCH + FAIL, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      cardsList: {
        ...initialState.cardsList,
        failed: true,
        // todo: Костыль
        data: payload
      }
    }))
    .addCase(MATERIALS_CARD + FETCH, (state) => ({
      ...state,
      oneCard: {
        ...initialState.oneCard,
        loading: true
      }
    }))
    .addCase(MATERIALS_CARD + FETCH + DONE, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      oneCard: {
        ...initialState.oneCard,
        success: true,
        data: payload
      }
    }))
    .addCase(MATERIALS_CARD + FETCH + FAIL, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      oneCard: {
        ...initialState.oneCard,
        failed: true,
        // todo: Костыль
        data: payload
      }
    }))
    .addCase(MATERIALS_GAME + FETCH, (state) => ({
      ...state,
      oneGame: {
        ...initialState.oneGame,
        loading: true
      }
    }))
    .addCase(MATERIALS_GAME + FETCH + DONE, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      oneGame: {
        ...initialState.oneGame,
        success: true,
        data: payload
      }
    }))
    .addCase(MATERIALS_GAME + FETCH + FAIL, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      oneGame: {
        ...initialState.oneGame,
        failed: true,
        // todo: Костыль
        data: payload
      }
    }))
    .addCase(MATERIALS + FETCH, (state) => ({
      ...state,
      materials: {
        ...initialState.materials,
        loading: true
      }
    }))
    .addCase(MATERIALS + FETCH + DONE, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      materials: {
        ...initialState.materials,
        success: true,
        data: payload
      }
    }))
    .addCase(MATERIALS + FETCH + FAIL, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      materials: {
        ...initialState.materials,
        failed: true,
        // todo: Костыль
        data: payload
      }
    }))
    .addCase(INFOGRAPHICS + FETCH, (state) => ({
      ...state,
      infographics: {
        ...initialState.infographics,
        loading: true
      }
    }))
    .addCase(INFOGRAPHICS + FETCH + DONE, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      infographics: {
        ...initialState.infographics,
        success: true,
        data: payload
      }
    }))
    .addCase(INFOGRAPHICS + FETCH + FAIL, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      infographics: {
        ...initialState.infographics,
        failed: true,
        // todo: Костыль
        data: payload
      }
    }))
    .addCase(MATERIALS_TREE + FETCH, (state) => ({
      ...state,
      materialsTree: {
        ...initialState.materialsTree,
        loading: true,
      },
    }))

    .addCase(MATERIALS_TREE + FETCH + DONE, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      materialsTree: {
        ...initialState.materialsTree,
        success: true,
        data: payload,
      },
    }))

    .addCase(MATERIALS_TREE + FETCH + FAIL, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      materialsTree: {
        ...initialState.materialsTree,
        failed: true,
        data: payload,
      },
    }))
     .addCase(MATERIALS_DETAIL + FETCH, (state) => ({
      ...state,
      materialsDetail: {
        ...initialState.materialsDetail,
        loading: true,
      },
    }))

    .addCase(MATERIALS_DETAIL + FETCH + DONE, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      materialsDetail: {
        ...initialState.materialsDetail,
        success: true,
        data: payload,
      },
    }))

    .addCase(MATERIALS_DETAIL + FETCH + FAIL, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      materialsDetail: {
        ...initialState.materialsDetail,
        failed: true,
        data: payload,
      },
    }))
    .addCase(KINDERGARTENS_LIST + FETCH, (state) => ({
      ...state,
      kindergartensList: {
        ...initialState.kindergartensList,
        loading: true,
      },
    }))
    .addCase(KINDERGARTENS_LIST + FETCH + DONE, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      kindergartensList: {
        ...initialState.kindergartensList,
        success: true,
        data: payload,
      },
    }))
    .addCase(KINDERGARTENS_LIST + FETCH + FAIL, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      kindergartensList: {
        ...initialState.kindergartensList,
        failed: true,
        data: payload,
      },
    }))
    .addCase(CHILDRENS + FETCH, (state) => ({
      ...state,
      childrens: {
        ...initialState.childrens,
        loading: true,
      },
    }))
    .addCase(CHILDRENS + FETCH + DONE, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      childrens: {
        ...initialState.childrens,
        success: true,
        data: payload,
      },
    }))
    .addCase(CHILDRENS + FETCH + FAIL, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      childrens: {
        ...initialState.childrens,
        failed: true,
        data: payload,
      },
    }))
    .addCase(MAIN_VIDEO_LIST + FETCH, (state) => ({
      ...state,
      mainVideoList: {
        ...initialState.mainVideoList,
        loading: true,
      },
    }))
    .addCase(MAIN_VIDEO_LIST + FETCH + DONE, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      mainVideoList: {
        ...initialState.mainVideoList,
        success: true,
        data: payload,
      },
    }))
    .addCase(MAIN_VIDEO_LIST + FETCH + FAIL, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      mainVideoList: {
        ...initialState.mainVideoList,
        failed: true,
        data: payload,
      },
    }))
    .addCase(CONTENT_BY_LESSON + FETCH, (state) => ({
      ...state,
      contentByLesson: {
        ...initialState.contentByLesson,
        loading: true,
      },
    }))
    .addCase(CONTENT_BY_LESSON + FETCH + DONE, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      contentByLesson: {
        ...initialState.contentByLesson,
        success: true,
        data: payload,
      },
    }))
    .addCase(CONTENT_BY_LESSON + FETCH + FAIL, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      contentByLesson: {
        ...initialState.contentByLesson,
        failed: true,
        data: payload,
      },
    }))
    .addCase(EXPORT_PDF + FETCH, (state) => ({
      ...state,
      exportPDF: {
        ...initialState.exportPDF,
        loading: true,
      },
    }))
    .addCase(EXPORT_PDF + FETCH + DONE, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      exportPDF: {
        ...initialState.exportPDF,
        success: true,
        data: payload,
      },
    }))
    .addCase(EXPORT_PDF + FETCH + FAIL, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      exportPDF: {
        ...initialState.exportPDF,
        failed: true,
        data: payload,
      },
    }))
    .addCase(SENSORY_VIDEO_LIST + FETCH, (state) => ({
      ...state,
      sensoryVideoList: {
        ...initialState.sensoryVideoList,
        loading: true,
      },
    }))
    .addCase(SENSORY_VIDEO_LIST + FETCH + DONE, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      sensoryVideoList: {
        ...initialState.sensoryVideoList,
        success: true,
        data: payload,
      },
    }))
    .addCase(SENSORY_VIDEO_LIST + FETCH + FAIL, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      sensoryVideoList: {
        ...initialState.sensoryVideoList,
        failed: true,
        data: payload,
      },
    }))
    .addCase(EXPORT_RESULTS_PDF + FETCH, (state) => ({
      ...state,
      exportResultsPDF: {
        ...initialState.exportResultsPDF,
        loading: true,
      },
    }))
    .addCase(EXPORT_RESULTS_PDF + FETCH + DONE, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      exportResultsPDF: {
        ...initialState.exportResultsPDF,
        success: true,
        data: payload,
      },
    }))
    .addCase(EXPORT_RESULTS_PDF + FETCH + FAIL, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      exportResultsPDF: {
        ...initialState.exportResultsPDF,
        failed: true,
        data: payload,
      },
    }))
    .addCase(INFOGRAPHICS_BY_CODE + FETCH, (state) => ({
      ...state,
      infographicsByCode: {
        ...initialState.infographicsByCode,
        loading: true,
      },
    }))
    .addCase(INFOGRAPHICS_BY_CODE + FETCH + DONE, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      infographicsByCode: {
        ...initialState.infographicsByCode,
        success: true,
        data: payload,
      },
    }))
    .addCase(INFOGRAPHICS_BY_CODE + FETCH + FAIL, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      infographicsByCode: {
        ...initialState.infographicsByCode,
        failed: true,
        data: payload,
      },
    }))
    .addCase(ARTICLE_BY_ID + FETCH, (state) => ({
      ...state,
      articleById: {
        ...initialState.articleById,
        loading: true,
      },
    }))
    .addCase(ARTICLE_BY_ID + FETCH + DONE, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      articleById: {
        ...initialState.articleById,
        success: true,
        data: payload,
      },
    }))
    .addCase(ARTICLE_BY_ID + FETCH + FAIL, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      articleById: {
        ...initialState.articleById,
        failed: true,
        data: payload,
      },
    }))
    .addCase(DELETE_CHILD + FETCH, (state) => ({
      ...state,
      deleteChild: {
        ...initialState.deleteChild,
        loading: true,
      },
    }))
    .addCase(DELETE_CHILD + FETCH + DONE, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      deleteChild: {
        ...initialState.deleteChild,
        success: true,
        data: payload,
      },
    }))
    .addCase(DELETE_CHILD + FETCH + FAIL, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      deleteChild: {
        ...initialState.deleteChild,
        failed: true,
        data: payload,
      },
    }))
    .addCase(PSYCHO_CARDS_LIST + FETCH, (state) => ({
      ...state,
      psychoCardsList: {
        ...initialState.psychoCardsList,
        loading: true,
      },
    }))
    .addCase(PSYCHO_CARDS_LIST + FETCH + DONE, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      psychoCardsList: {
        ...initialState.psychoCardsList,
        success: true,
        data: payload,
      },
    }))
    .addCase(PSYCHO_CARDS_LIST + FETCH + FAIL, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      psychoCardsList: {
        ...initialState.psychoCardsList,
        failed: true,
        data: payload,
      },
    }))
    .addCase(UPDATE_PROFILE + FETCH, (state) => ({
      ...state,
      updateProfile: {
        ...initialState.updateProfile,
        loading: true,
      },
    }))
    .addCase(UPDATE_PROFILE + FETCH + DONE, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      updateProfile: {
        ...initialState.updateProfile,
        success: true,
        data: payload,
      },
    }))
    .addCase(UPDATE_PROFILE + FETCH + FAIL, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      updateProfile: {
        ...initialState.updateProfile,
        failed: true,
        data: payload,
      },
    }))
    .addCase(ADD_CHILD + FETCH, (state) => ({
      ...state,
      addChild: {
        ...initialState.addChild,
        loading: true,
      },
    }))
    .addCase(ADD_CHILD + FETCH + DONE, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      addChild: {
        ...initialState.addChild,
        success: true,
        data: payload,
      },
    }))
    .addCase(ADD_CHILD + FETCH + FAIL, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      addChild: {
        ...initialState.addChild,
        failed: true,
        data: payload,
      },
    }))
    .addCase(UPDATE_CHILD + FETCH, (state) => ({
      ...state,
      updateChild: {
        ...initialState.updateChild,
        loading: true,
      },
    }))
    .addCase(UPDATE_CHILD + FETCH + DONE, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      updateChild: {
        ...initialState.updateChild,
        success: true,
        data: payload,
      },
    }))
    .addCase(UPDATE_CHILD + FETCH + FAIL, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      updateChild: {
        ...initialState.updateChild,
        failed: true,
        data: payload,
      },
    }))
    .addCase(CARDS_THEME_LIST + FETCH, (state) => ({
      ...state,
      cardsThemeList: {
        ...initialState.cardsThemeList,
        loading: true,
      },
    }))
    .addCase(CARDS_THEME_LIST + FETCH + DONE, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      cardsThemeList: {
        ...initialState.cardsThemeList,
        success: true,
        data: payload,
      },
    }))
    .addCase(CARDS_THEME_LIST + FETCH + FAIL, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      cardsThemeList: {
        ...initialState.cardsThemeList,
        failed: true,
        data: payload,
      },
    }))
    .addCase(EVALUATE + FETCH, (state) => ({
      ...state,
      evaluate: {
        ...initialState.evaluate,
        loading: true,
      },
    }))
    .addCase(EVALUATE + FETCH + DONE, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      evaluate: {
        ...initialState.evaluate,
        success: true,
        data: payload,
      },
    }))
    .addCase(EVALUATE + FETCH + FAIL, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      evaluate: {
        ...initialState.evaluate,
        failed: true,
        data: payload,
      },
    }))
    .addCase(EVALUATE + RESET, (state) => ({
      ...state,
      evaluate: {
        ...initialState.evaluate,
      },
    }))
    .addCase(TEST_RESULTS + FETCH, (state) => ({
      ...state,
      testResults: {
        ...initialState.testResults,
        loading: true,
      },
    }))
    .addCase(TEST_RESULTS + FETCH + DONE, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      testResults: {
        ...initialState.testResults,
        success: true,
        data: payload,
      },
    }))
    .addCase(TEST_RESULTS + FETCH + FAIL, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      testResults: {
        ...initialState.testResults,
        failed: true,
        data: payload,
      },
    }))
    .addCase(REGIONS_LIST + FETCH, (state) => ({
      ...state,
      regionsList: {
        ...initialState.regionsList,
        loading: true,
      },
    }))
    .addCase(REGIONS_LIST + FETCH + DONE, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      regionsList: {
        ...initialState.regionsList,
        success: true,
        data: payload,
      },
    }))
    .addCase(REGIONS_LIST + FETCH + FAIL, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      regionsList: {
        ...initialState.regionsList,
        failed: true,
        data: payload,
      },
    }))
    .addCase(DISTRICTS_LIST + FETCH, (state) => ({
      ...state,
      districtsList: {
        ...initialState.districtsList,
        loading: true,
      },
    }))
    .addCase(DISTRICTS_LIST + FETCH + DONE, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      districtsList: {
        ...initialState.districtsList,
        success: true,
        data: payload,
      },
    }))
    .addCase(DISTRICTS_LIST + FETCH + FAIL, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      districtsList: {
        ...initialState.districtsList,
        failed: true,
        data: payload,
      },
    }))
    .addCase(CITIES_LIST + FETCH, (state) => ({
      ...state,
      citiesList: {
        ...initialState.citiesList,
        loading: true,
      },
    }))
    .addCase(CITIES_LIST + FETCH + DONE, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      citiesList: {
        ...initialState.citiesList,
        success: true,
        data: payload,
      },
    }))
    .addCase(CITIES_LIST + FETCH + FAIL, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      citiesList: {
        ...initialState.citiesList,
        failed: true,
        data: payload,
      },
    }))
    .addCase(LIST_REQUEST + FETCH, (state) => ({
      ...state,
      listRequest: {
        ...initialState.listRequest,
        loading: true,
      },
    }))
    .addCase(LIST_REQUEST + FETCH + DONE, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      listRequest: {
        ...initialState.listRequest,
        success: true,
        data: payload,
      },
    }))
    .addCase(LIST_REQUEST + FETCH + FAIL, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      listRequest: {
        ...initialState.listRequest,
        failed: true,
        data: payload,
      },
    }))
    .addCase(CREATE_APPLICATION + FETCH, (state) => ({
      ...state,
      createApplication: {
        ...initialState.createApplication,
        loading: true,
      },
    }))
    .addCase(CREATE_APPLICATION + FETCH + DONE, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      createApplication: {
        ...initialState.createApplication,
        success: true,
        data: payload,
      },
    }))
    .addCase(CREATE_APPLICATION + FETCH + FAIL, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      createApplication: {
        ...initialState.createApplication,
        failed: true,
        data: payload,
      },
    }))
    .addCase(SET_LIKE + FETCH, (state) => ({
      ...state,
      setLike: {
        ...initialState.setLike,
        loading: true,
      },
    }))
    .addCase(SET_LIKE + FETCH + DONE, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      setLike: {
        ...initialState.setLike,
        success: true,
        data: payload,
      },
    }))
    .addCase(SET_LIKE + FETCH + FAIL, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      setLike: {
        ...initialState.setLike,
        failed: true,
        data: payload,
      },
    }))
    .addCase(CONTENT_BY_CATEGORY + FETCH, (state) => ({
      ...state,
      contentByCategory: {
        ...initialState.contentByCategory,
        loading: true,
      },
    }))
    .addCase(CONTENT_BY_CATEGORY + FETCH + DONE, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      contentByCategory: {
        ...initialState.contentByCategory,
        success: true,
        data: payload,
      },
    }))
    .addCase(CONTENT_BY_CATEGORY + FETCH + FAIL, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      contentByCategory: {
        ...initialState.contentByCategory,
        failed: true,
        data: payload,
      },
    }))
    .addCase(FETCH_MARATHON_WEEKS + FETCH, (state) => ({
      ...state,
      weeksList: {
        ...initialState.weeksList,
        loading: true
      }
    }))
    .addCase(FETCH_MARATHON_WEEKS + FETCH + DONE, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      weeksList: {
        ...initialState.weeksList,
        success: true,
        data: payload
      }
    }))
    .addCase(FETCH_MARATHON_WEEKS + FETCH + FAIL, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      weeksList: {
        ...initialState.weeksList,
        failed: true,
        data: payload
      }
    }))

    .addCase(FETCH_MARATHON_DAYS + FETCH, (state) => ({
      ...state,
      daysList: {
        ...initialState.daysList,
        loading: true
      }
    }))
    .addCase(FETCH_MARATHON_DAYS + FETCH + DONE, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      daysList: {
        ...initialState.daysList,
        success: true,
        data: payload
      }
    }))
    .addCase(FETCH_MARATHON_DAYS + FETCH + FAIL, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      daysList: {
        ...initialState.daysList,
        failed: true,
        data: payload
      }
    }))

    .addCase(FETCH_MARATHON_TASKS + FETCH, (state) => ({
      ...state,
      tasksList: {
        ...initialState.tasksList,
        loading: true
      }
    }))
    .addCase(FETCH_MARATHON_TASKS + FETCH + DONE, (state, {payload}: PayloadAction<any>) => {
        const dayId = payload?.day?.id;
        return {
            ...state,
            tasksList: {
                ...state.tasksList,
                loading: false,
                success: true,
                data: payload,
            },
            tasksByDay: {
                ...state.tasksByDay,
                ...(dayId ? { [dayId]: payload.tasks } : {}),
            },
        };
    })
    .addCase(FETCH_MARATHON_TASKS + FETCH + FAIL, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      tasksList: {
        ...initialState.tasksList,
        failed: true,
        data: payload
      }
    }))

    .addCase(FETCH_MARATHON_TASK + FETCH, (state) => ({
      ...state,
      taskDetail: {
        ...initialState.taskDetail,
        loading: true
      }
    }))
    .addCase(FETCH_MARATHON_TASK + FETCH + DONE, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      taskDetail: {
        ...initialState.taskDetail,
        success: true,
        data: payload
      }
    }))
    .addCase(FETCH_MARATHON_TASK + FETCH + FAIL, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      taskDetail: {
        ...initialState.taskDetail,
        failed: true,
        data: payload
      }
    }))
    .addCase(SAVE_DIARY + FETCH, (state) => ({
      ...state,
      saveDiary: {
        ...initialState.saveDiary,
        loading: true
      }
    }))
    .addCase(SAVE_DIARY + FETCH + DONE, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      saveDiary: {
        ...initialState.saveDiary,
        success: true,
        data: payload
      }
    }))
    .addCase(SAVE_DIARY + FETCH + FAIL, (state, {payload}: PayloadAction<any>) => ({
      ...state,
      saveDiary: {
        ...initialState.saveDiary,
        failed: true,
        data: payload
      }
    }))
    .addCase(FETCH_DIARY + FETCH, (state) => ({
      ...state,
      diary: { ...initialState.diary, loading: true }
    }))
    .addCase(FETCH_DIARY + FETCH + DONE, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      diary: { ...initialState.diary, success: true, data: payload }
    }))
    .addCase(FETCH_DIARY + FETCH + FAIL, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      diary: { ...initialState.diary, failed: true, data: payload }
    }))
    .addCase(FETCH_DIARY_TABLE + FETCH, (state) => ({
      ...state,
      diaryTable: { ...initialState.diaryTable, loading: true }
    }))
    .addCase(FETCH_DIARY_TABLE + FETCH + DONE, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      diaryTable: { ...initialState.diaryTable, success: true, data: payload }
    }))
    .addCase(FETCH_DIARY_TABLE + FETCH + FAIL, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      diaryTable: { ...initialState.diaryTable, failed: true, data: payload }
    }))
    .addCase(TASK_COMPLETE + FETCH, (state) => ({
      ...state,
      taskComplete: { ...initialState.taskComplete, loading: true }
    }))
    .addCase(TASK_COMPLETE + FETCH + DONE, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      taskComplete: { ...initialState.taskComplete, success: true, data: payload }
    }))
    .addCase(TASK_COMPLETE + FETCH + FAIL, (state, { payload }: PayloadAction<any>) => ({
      ...state,
      taskComplete: { ...initialState.taskComplete, failed: true, data: payload }
    }))
    .addCase(SET + SELECTED_CHILD_ID, (state, { payload }: PayloadAction<any>) => {
      try {
        localStorage.setItem('selectedChildId', String(payload));
      } catch {}
      return {
        ...state,
        selectedChildId: {
          ...state.selectedChildId,
          success: true,
          data: payload,
        }
      };
    })
    .addCase(SET + DIAGNOSTIC_RESULT, (state, { payload }: PayloadAction<{ childId: number | string; result: any }>) => {
      const updated = {
        ...state.diagnosticResults.data,
        [payload.childId]: payload.result,
      };
      try {
        localStorage.setItem('diagnosticResults', JSON.stringify(updated));
      } catch {}
      return {
        ...state,
        diagnosticResults: {
          ...state.diagnosticResults,
          success: true,
          data: updated,
        }
      };
    })
    .addCase(RESET + CREATE_APPLICATION, (state) => ({
      ...state,
      createApplication: { ...initialState.createApplication }
    }))
    .addCase(SET + TASK_COMPLETED_LOCAL, (state, { payload }: PayloadAction<any>) => {
      const currentTasks = (state.tasksByDay as unknown as Record<string, any[]>)[payload.dayId] ?? [];
      return {
        ...state,
        tasksByDay: {
          ...state.tasksByDay,
          [payload.dayId]: currentTasks.map((t: any) =>
            t.id === payload.taskId ? { ...t, is_completed: payload.completed } : t
          ),
        }
      };
    })
)
